import React from 'react';
import { Button, Card, CardContent } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden/Hidden';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import DetailsListItem from 'modules2/components/DetailsListItem';
import container from './Top10Card.container';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    // marginBottom: theme.spacing(1),
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  nextBtn: {
    color: '#ffffff',
    width: 300,
    fontWeight: 400,
    fontFamily: 'Arial',
    textTransform: 'uppercase',
    paddingTop: 10,
    marginBottom: 10,
    backgroundColor: theme.palette.buttonBackground,
    '&:hover': {
      backgroundColor: theme.palette.nextBtnHover,
    },
  },
}));

const Top10Card = (props) => {
  const classes = useStyles();
  const {
    radioState: { radios },
    userHistoryRadioState: { heartedStationIds },
    onViewRadioPlayerStart,
    onFavouriteRadioStation,
    onDeleteFavoriteRadioStation,
    onShowSnackbarNotification,
  } = props;

  const onClickHandler = (id) => {
    onViewRadioPlayerStart(id);
  };

  const onFavouriteClick = (id) => {
    if (
        heartedStationIds.some((stationId) => stationId === id)
    ) {
      onShowSnackbarNotification(`Radio deleted from favorite 😢`);
      onDeleteFavoriteRadioStation(id);
    } else {
      onShowSnackbarNotification(`Radio Hearted ❤️`);
      onFavouriteRadioStation(id);
    }
  };

  const displayTopList = (loading, num) => {
    if (loading) {
      return [...Array(num)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    return (
      radios &&
      Object.keys(radios)
        .slice(71, 81)
        .map((id, index) => {
          return (
            <DetailsListItem
              key={radios[id].stationuuid}
              stationid={radios[id].stationuuid}
              hearted={false}
              heart
              isPlayed={false}
              isPinned={false}
              image={radios[id].favicon}
              title={radios[id].name}
              subtitle={radios[id].tags}
              url={radios[id].url_resolved}
              radio_id={radios[id].stationuiid}
              radio={radios[id]}
              onClick={onClickHandler}
              onFavouriteClick={onFavouriteClick}
            />
          );
        })
    );
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden smDown>
          <div className={classes.listContainer}>
            {displayTopList(false, 3)}
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.listContainer}>
            {displayTopList(false, 1)}
          </div>
        </Hidden>
      </CardContent>
    </Card>
  );
};

export default container(Top10Card);
